(function(){
const sel = (s, r=document) => r.querySelector(s);
const IST_OFFSET_MIN = 330; // IST = UTC+5:30
function nowInIST(){
const now = new Date();
// Convert to IST by adding offset difference between local TZ and IST
const localOffsetMin = now.getTimezoneOffset();
const diffMin = localOffsetMin + IST_OFFSET_MIN * -1; // careful with
signs
return new Date(now.getTime() + (IST_OFFSET_MIN + localOffsetMin) *
60000 * -1);
}
function parseHolidayList(str){
if(!str) return [];
return str.split(',').map(s=>s.trim()).filter(Boolean);
}
function isSunday(d){ return d.getDay() === 0; }
function isHoliday(d, holidays){
const iso = d.toISOString().slice(0,10);
return holidays.includes(iso);
}
function addBusinessDays(start, days, holidays){
const d = new Date(start.getFullYear(), start.getMonth(),
start.getDate());
let added = 0;
while(added < days){
d.setDate(d.getDate() + 1);
if(!isSunday(d) && !isHoliday(d, holidays)) added++;
}
return d;
}
function formatDate(d){
const opts = { weekday: 'short', day:'2-digit', month:'short' };
return d.toLocaleDateString(undefined, opts);
}
async function loadSLA(){
if(window.__PIN_SLA__) return window.__PIN_SLA__;
const res = await fetch(`${Shopify.asset_url || ''}{{ 'pincode-sla.json'
| asset_url }}`);

const data = await res.json();
window.__PIN_SLA__ = data;
return data;
}
function getSlaForPin(pin, map, def){
const p = String(pin || '').trim();
if(!/^\d{6}$/.test(p)) return null;
const k = p.slice(0,3);
return map[k] || def;
}
function computeWindow({ transitMin, transitMax, handlingDays,
cutoffHourIST, holidays }){
const nowIST = nowInIST();
// If past cutoff, add 1 handling day
let h = Number(handlingDays)||0;
if(nowIST.getHours() >= Number(cutoffHourIST||13)) h += 1;
const startBase = addBusinessDays(nowIST, h, holidays);
const earliest = addBusinessDays(startBase, Number(transitMin||0),
holidays);
const latest = addBusinessDays(startBase, Number(transitMax||0),
holidays);
return { earliest, latest };
}
function renderMessage({ pin, earliest, latest }){
return `Get it between <strong>${formatDate(earliest)}</strong> —
<strong>${formatDate(latest)}</strong> to <strong>${pin}</strong>`;
}
function mount(root){
if(!root) return;
const input = sel('#de-pin', root);
const btn = sel('#de-check', root);
const out = sel('#de-result', root);
let holidays = parseHolidayList(root.dataset.holidays);
const cutoff = Number(root.dataset.cutoffHour || 13);
const defMin = Number(root.dataset.defaultMin || 3);
const defMax = Number(root.dataset.defaultMax || 7);
const handling = Number(root.dataset.handlingDays || 0);
function error(msg){ out.innerHTML = `<span style="color:#c00">${msg}</
span>`; }
async function onCheck(){
const pin = (input.value||'').trim();
if(!/^\d{6}$/.test(pin)) { error('Please enter a valid 6‑digit PIN.');

return; }
try{
const map = await loadSLA();
const def = map.default || { min: defMin, max: defMax };
const sla = getSlaForPin(pin, map, def);
if(!sla){ error('Please enter a valid 6‑digit PIN.'); return; }
const { earliest, latest } = computeWindow({
transitMin: sla.min,
transitMax: sla.max,
handlingDays: handling,
cutoffHourIST: cutoff,
holidays
});
out.innerHTML = renderMessage({ pin, earliest, latest });
} catch(e){
console.error(e);
error('Could not check delivery time right now. Please try again.');
}
}
btn.addEventListener('click', onCheck);
input.addEventListener('keyup', (e)=>{ if(e.key==='Enter') onCheck(); });
}
document.addEventListener('DOMContentLoaded', function(){
document.querySelectorAll('.delivery-estimator').forEach(mount);
});
})();